import { useState } from 'react'
import { Dayjs } from 'dayjs'

import Styles from './CustomSchedule.module.scss'

import { CustomScheduler } from '../CustomScheduler/CustomScheduler'
import { DayAndTime } from '../../StartDateAndPostFrequencyModal'
import { Button } from 'blaze-ui/Button'
import { PostingCadence } from '../../../../ScheduleContent'
import { Drawer } from 'components/Drawer'

interface Props {
  initialDays: DayAndTime[]
  startDate: Dayjs
  customTime: string | undefined
  onConfirm: (postingCadence: PostingCadence, days: DayAndTime[]) => void
}

export const CustomSchedule = ({ initialDays, startDate, customTime, onConfirm }: Props) => {
  const [days, setDays] = useState(initialDays)

  const handleConfirm = () => {
    onConfirm(PostingCadence.Custom, days)
  }

  return (
    <>
      <Drawer.Container>
        <div className={Styles.container}>
          <CustomScheduler
            title="Choose your days"
            days={days}
            setDays={setDays}
            startDate={startDate}
            customTime={customTime}
          />
          <Button onPress={handleConfirm}>Confirm</Button>
        </div>
      </Drawer.Container>
    </>
  )
}
